import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2a30b464 from 'nuxt_plugin_plugin_2a30b464' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_router_2623e575 from 'nuxt_plugin_router_2623e575' // Source: ./router.js (mode: 'all')
import nuxt_plugin_vuelidate_eab611d0 from 'nuxt_plugin_vuelidate_eab611d0' // Source: ./vuelidate (mode: 'all')
import nuxt_plugin_modervel_b6f80934 from 'nuxt_plugin_modervel_b6f80934' // Source: ./moder-vel (mode: 'all')
import nuxt_plugin_moderlibrary_6d8ff436 from 'nuxt_plugin_moderlibrary_6d8ff436' // Source: ./moderlibrary (mode: 'all')
import nuxt_plugin_storage_d0e2c9d6 from 'nuxt_plugin_storage_d0e2c9d6' // Source: ./storage.js (mode: 'all')
import nuxt_plugin_pluginutils_eda507fe from 'nuxt_plugin_pluginutils_eda507fe' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_ac81e5e8 from 'nuxt_plugin_pluginrouting_ac81e5e8' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e204c3a from 'nuxt_plugin_pluginmain_7e204c3a' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_bed9550c from 'nuxt_plugin_axios_bed9550c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_route_192d86f8 from 'nuxt_plugin_route_192d86f8' // Source: ../plugins/route.js (mode: 'all')
import nuxt_plugin_handleError_17356ba6 from 'nuxt_plugin_handleError_17356ba6' // Source: ../plugins/handleError.js (mode: 'all')
import nuxt_plugin_storeRouteBackup_91061d80 from 'nuxt_plugin_storeRouteBackup_91061d80' // Source: ../plugins/storeRouteBackup (mode: 'all')
import nuxt_plugin_isAuth_5cd23630 from 'nuxt_plugin_isAuth_5cd23630' // Source: ../plugins/isAuth (mode: 'all')
import nuxt_plugin_isMobile_48e2703c from 'nuxt_plugin_isMobile_48e2703c' // Source: ../plugins/isMobile (mode: 'all')
import nuxt_plugin_isInIframe_33c0b369 from 'nuxt_plugin_isInIframe_33c0b369' // Source: ../plugins/isInIframe (mode: 'all')
import nuxt_plugin_ga_fb0a2534 from 'nuxt_plugin_ga_fb0a2534' // Source: ../plugins/ga.js (mode: 'client')
import nuxt_plugin_resetApp_43961870 from 'nuxt_plugin_resetApp_43961870' // Source: ../plugins/resetApp (mode: 'all')
import nuxt_plugin_slug_6a865b21 from 'nuxt_plugin_slug_6a865b21' // Source: ../plugins/slug (mode: 'all')
import nuxt_plugin_convertColorToHex_7614725a from 'nuxt_plugin_convertColorToHex_7614725a' // Source: ../plugins/convertColorToHex (mode: 'client')
import nuxt_plugin_setDynColors_14310506 from 'nuxt_plugin_setDynColors_14310506' // Source: ../plugins/setDynColors (mode: 'client')
import nuxt_plugin_getRoomName_329f0646 from 'nuxt_plugin_getRoomName_329f0646' // Source: ../plugins/getRoomName (mode: 'all')
import nuxt_plugin_setClientHeight_7626841e from 'nuxt_plugin_setClientHeight_7626841e' // Source: ../plugins/setClientHeight (mode: 'client')
import nuxt_plugin_vueawesomeswiper_4af85e3f from 'nuxt_plugin_vueawesomeswiper_4af85e3f' // Source: ../plugins/vue-awesome-swiper (mode: 'client')
import nuxt_plugin_map_50fe1bde from 'nuxt_plugin_map_50fe1bde' // Source: ../plugins/map.js (mode: 'client')
import nuxt_plugin_vuelidate_4345260a from 'nuxt_plugin_vuelidate_4345260a' // Source: ../plugins/vuelidate (mode: 'all')
import nuxt_plugin_vcalendar_5419a6aa from 'nuxt_plugin_vcalendar_5419a6aa' // Source: ../plugins/v-calendar.js (mode: 'client')
import nuxt_plugin_md5_5e464e48 from 'nuxt_plugin_md5_5e464e48' // Source: ../plugins/md5 (mode: 'all')
import nuxt_plugin_prefixLinks_52634574 from 'nuxt_plugin_prefixLinks_52634574' // Source: ../plugins/prefixLinks.js (mode: 'client')
import nuxt_plugin_vuecompositionapi_5cc0340c from 'nuxt_plugin_vuecompositionapi_5cc0340c' // Source: ../plugins/vue-composition-api (mode: 'all')
import nuxt_plugin_headers_1636a350 from 'nuxt_plugin_headers_1636a350' // Source: ../plugins/headers (mode: 'all')
import nuxt_plugin_helpers_16d71a4f from 'nuxt_plugin_helpers_16d71a4f' // Source: ../plugins/helpers (mode: 'client')
import nuxt_plugin_axios_70c68075 from 'nuxt_plugin_axios_70c68075' // Source: ../node_modules/moder-vel/nuxt/plugins/axios (mode: 'all')
import nuxt_plugin_store_71c26ce0 from 'nuxt_plugin_store_71c26ce0' // Source: ../node_modules/moder-vel/nuxt/plugins/store (mode: 'all')
import nuxt_plugin_vuejsmodal_c7259e9e from 'nuxt_plugin_vuejsmodal_c7259e9e' // Source: ../node_modules/moder-vel/nuxt/plugins/vue-js-modal (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: function() {
    const promoter = this.$route?.params?.promoter?.toUpperCase();
    const program = this.$route?.params?.program;
    const title = `${promoter} | ${program} by MODERLAB`;
    const url = `https://www.moderlife.com/${promoter}/${program}`;
    const image = '/moderlab.png';
    return {
      title: 'moderlife',
      htmlAttrs: {
        lang: 'fr'
      },
      meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'format-detection', content: 'telephone=no' },
      { hid: 'robots', name: 'robots', content: 'noindex, nofollow' },
      { hid: 'description', name: 'description', content: title },
      { hid: 'og:type', name: 'og:type', content: 'website' },
      { hid: 'og:url', name: 'og:url', content: 'https://www.moderlife.com' },
      { hid: 'og:title', name: 'og:title', content: title },
      { hid: 'og:site_name', name: 'og:site_name', content: title },
      { hid: 'og:image', name: 'og:image', content: image },
      { name: 'twitter:title', content: title },
      { name: 'twitter:image', content: image },
      { name: 'twitter:url', content: url }],

      link: [
      { rel: 'icon', type: 'image/x-icon', href: '/moderlab_logo.png' }]
    };
  },

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2a30b464 === 'function') {
    await nuxt_plugin_plugin_2a30b464(app.context, inject)
  }

  if (typeof nuxt_plugin_router_2623e575 === 'function') {
    await nuxt_plugin_router_2623e575(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_eab611d0 === 'function') {
    await nuxt_plugin_vuelidate_eab611d0(app.context, inject)
  }

  if (typeof nuxt_plugin_modervel_b6f80934 === 'function') {
    await nuxt_plugin_modervel_b6f80934(app.context, inject)
  }

  if (typeof nuxt_plugin_moderlibrary_6d8ff436 === 'function') {
    await nuxt_plugin_moderlibrary_6d8ff436(app.context, inject)
  }

  if (typeof nuxt_plugin_storage_d0e2c9d6 === 'function') {
    await nuxt_plugin_storage_d0e2c9d6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_eda507fe === 'function') {
    await nuxt_plugin_pluginutils_eda507fe(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_ac81e5e8 === 'function') {
    await nuxt_plugin_pluginrouting_ac81e5e8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e204c3a === 'function') {
    await nuxt_plugin_pluginmain_7e204c3a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_bed9550c === 'function') {
    await nuxt_plugin_axios_bed9550c(app.context, inject)
  }

  if (typeof nuxt_plugin_route_192d86f8 === 'function') {
    await nuxt_plugin_route_192d86f8(app.context, inject)
  }

  if (typeof nuxt_plugin_handleError_17356ba6 === 'function') {
    await nuxt_plugin_handleError_17356ba6(app.context, inject)
  }

  if (typeof nuxt_plugin_storeRouteBackup_91061d80 === 'function') {
    await nuxt_plugin_storeRouteBackup_91061d80(app.context, inject)
  }

  if (typeof nuxt_plugin_isAuth_5cd23630 === 'function') {
    await nuxt_plugin_isAuth_5cd23630(app.context, inject)
  }

  if (typeof nuxt_plugin_isMobile_48e2703c === 'function') {
    await nuxt_plugin_isMobile_48e2703c(app.context, inject)
  }

  if (typeof nuxt_plugin_isInIframe_33c0b369 === 'function') {
    await nuxt_plugin_isInIframe_33c0b369(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ga_fb0a2534 === 'function') {
    await nuxt_plugin_ga_fb0a2534(app.context, inject)
  }

  if (typeof nuxt_plugin_resetApp_43961870 === 'function') {
    await nuxt_plugin_resetApp_43961870(app.context, inject)
  }

  if (typeof nuxt_plugin_slug_6a865b21 === 'function') {
    await nuxt_plugin_slug_6a865b21(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_convertColorToHex_7614725a === 'function') {
    await nuxt_plugin_convertColorToHex_7614725a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_setDynColors_14310506 === 'function') {
    await nuxt_plugin_setDynColors_14310506(app.context, inject)
  }

  if (typeof nuxt_plugin_getRoomName_329f0646 === 'function') {
    await nuxt_plugin_getRoomName_329f0646(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_setClientHeight_7626841e === 'function') {
    await nuxt_plugin_setClientHeight_7626841e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_4af85e3f === 'function') {
    await nuxt_plugin_vueawesomeswiper_4af85e3f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_map_50fe1bde === 'function') {
    await nuxt_plugin_map_50fe1bde(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4345260a === 'function') {
    await nuxt_plugin_vuelidate_4345260a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_5419a6aa === 'function') {
    await nuxt_plugin_vcalendar_5419a6aa(app.context, inject)
  }

  if (typeof nuxt_plugin_md5_5e464e48 === 'function') {
    await nuxt_plugin_md5_5e464e48(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_prefixLinks_52634574 === 'function') {
    await nuxt_plugin_prefixLinks_52634574(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecompositionapi_5cc0340c === 'function') {
    await nuxt_plugin_vuecompositionapi_5cc0340c(app.context, inject)
  }

  if (typeof nuxt_plugin_headers_1636a350 === 'function') {
    await nuxt_plugin_headers_1636a350(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_helpers_16d71a4f === 'function') {
    await nuxt_plugin_helpers_16d71a4f(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_70c68075 === 'function') {
    await nuxt_plugin_axios_70c68075(app.context, inject)
  }

  if (typeof nuxt_plugin_store_71c26ce0 === 'function') {
    await nuxt_plugin_store_71c26ce0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsmodal_c7259e9e === 'function') {
    await nuxt_plugin_vuejsmodal_c7259e9e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
